baseApp.service('NetworkRulesService', function() {

    // we can add cache to prevent multiple calls when page is re-loaded but we need to invalidate it when sites configuration is changed
    var networkRulesService = {
        defaultsEnum: {
            NONE: 0,
            PRIMARY: 1,
            SECONDARY: 2
        },
        catoKey: '_WAN',
        offCloudKey: '_OFF_CLOUD',
        autoKey: 'automatic',

        networkTrafficCache: '',
        networkNICCache: ''
    };

    var trafficOptionsMapper = {
        '_WAN': {value: '_WAN', label: 'Cato'},
        '_ALTERNATIVE_WAN': {value: '_ALTERNATIVE_WAN', label: 'Alternative WAN'},
        '_OFF_CLOUD': {value: '_OFF_CLOUD', label: 'Off Cloud'},
        '_AUTOMATIC': {value: '_AUTOMATIC', label: 'Automatic'}
    };

    var NICOptionsMapper = {
        automatic: {value: 'automatic', label: 'Automatic'},
        wan_1: {value: 'wan_1', label: 'WAN 1', description: 'Applicable for Socket sites interfaces only, as per the interface role configuration'},
        wan_2: {value: 'wan_2', label: 'WAN 2', description: 'Applicable for Socket sites interfaces only, as per the interface role configuration'},
        wan_3: {value: 'wan_3', label: 'WAN 3', description: 'Applicable for Socket sites interfaces only, as per the interface role configuration'},
        ALT_WAN: {value: 'ALT_WAN', label: 'Alternative WAN', description: 'Applicable for socket sites where Alt. WAN has been configured'},
        LAN1: {value: 'LAN1', label: 'LAN 1'},
        LAN2: {value: 'LAN2', label: 'LAN 2'},
        Primary: {value: 'Primary', label: 'Primary', description: 'Applicable for IPsec sites'},
        Secondary: {value: 'Secondary', label: 'Secondary', description: 'Applicable for IPsec sites'},
    }

    var getMappedOptionsList = function(list, mapper) {
        var result = [];
        list.forEach(function(item) {
            result.push(mapper[item]);
        });
        return result;
    }

    var getListWithDefaults = function(list, primaryDefault, secondaryDefault) {
        list.forEach(function(item) {
            item.default = item.value === primaryDefault ? networkRulesService.defaultsEnum.PRIMARY :
                (item.value === secondaryDefault ? networkRulesService.defaultsEnum.SECONDARY :
                    networkRulesService.defaultsEnum.NONE)
        });
        return list;
    }

    var getMappedOptions = function(data, mapper) {
        return {
            WAN: getListWithDefaults(getMappedOptionsList(data.lists.WAN, mapper), data.primaryDefaults.WAN, data.secondaryDefaults.WAN),
            Internet: getListWithDefaults(getMappedOptionsList(data.lists.Internet, mapper), data.primaryDefaults.Internet, data.secondaryDefaults.Internet)
        }
    }

    networkRulesService.getValueOfDefault = function (list, defaultType) {
        var found = _.findWhere(list, {default: defaultType});
        return '' || (found && found.value);
    }

    networkRulesService.getNetworkTrafficOptions = function(accountId, callback) {
        store.fetch({
        	method: 'GET',
        	path: '/accountTransportOptions',
        	queryParams: {'accountId': accountId || ''},
        	success: function(data) {
        		callback(getMappedOptions(data, trafficOptionsMapper));
        	}
        });
    }

    networkRulesService.getNetworkNICOptions = function(accountId, callback) {
        store.fetch({
        	method: 'GET',
        	path: '/accountNICOptions',
        	queryParams: {'accountId': accountId || ''},
        	success: function(data) {
        	    callback(getMappedOptions(data, NICOptionsMapper));
        	}
        });
    }

    networkRulesService.getNICOptionsForQuality = function(accountId, callback) {
        store.fetch({
        	method: 'GET',
        	path: '/accountInterfacesForQualityAlerts',
        	queryParams: {'accountId': accountId || ''},
        	success: function(data) {
        	    callback(getMappedOptionsList(data, NICOptionsMapper));
        	}
        });
    }

    networkRulesService.getNICOptionsIds = function(options) {
        return getMappedOptionsList(options, NICOptionsMapper);
    }

    return networkRulesService;
});
